import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import IOSSwitch from "../../../users/formComponents/IOSSwitch";
import { useNavigate } from "react-router-dom";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "30dvw",
  //   height: "40dvh",
  minWidth: "400px",
  //   minHeight: "400px",
  bgcolor: "#242743",
  //   border: "1px solid #414466",
  boxShadow: 24,
  display: "flex",
  flexDirection: "column",
  outline: "none",
  borderRadius: "10px",
  padding: "20px",

  //   p: 4,
};

const headStype = {
  //   padding: "15px 15px",
  //   borderBottom: "1px solid #414466",
  display: "flex",
  alignItems: "start",
  justifyContent: "start",
};

const contentStyle = {
  //   padding: "15px 15px",
  flexGrow: "1",
  display: "flex",
  flexDirection: "column",
  overflow: "auto",
};

export default function GoalModal({ open, setOpen,  }) {
  //   const [confirm, setConfirm] = useState(false);
  const navigate = useNavigate();
  return (
    <Modal
      open={open}
      onClose={() => {
        // setOpen(false);
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Box sx={headStype}>
          <Box sx={{ flexGrow: "1" }}>
            <Typography
              component={"span"}
              sx={{
                fontSize: { sm: "18px", lg: "18px", xs: "16px" },
                color: "white",
                fontWeight: "bold",
              }}
            >
              Trial Period Expired!
            </Typography>
          </Box>
        </Box>

        {/* <Box sx={{ borderBottom: "1px solid #414466" }}></Box> */}
        <Box sx={contentStyle}>
          <Box sx={{ marginTop: "10px", flexGrow: "1" }}>
            <Typography
              component="p"
              sx={{
                color: "#9091a1",
                fontSize: { sm: "14px", xs: "12px", md: "16px" },
              }}
            >
              Please register or login to continue using Mynetgoals
            </Typography>
          </Box>
          {/* <Box
            sx={{
              marginTop: "10px",
              flexGrow: "1",
              color: "white",
              display: "flex",
              gap: "10px",
            }}
          >
            <IOSSwitch
              checked={confirm}
              onChange={(e) => {
                
                setConfirm(e.target.checked);
              }}
            />
            <Typography component="p">
              I confirm that i am above 12 years of age
            </Typography>
          </Box> */}
          <Box
            sx={{
              marginTop: "10px",
              flexGrow: "1",
              display: "flex",
              flexDirection: "row-reverse",
            }}
          >
            {/* <Button
              sx={{ color: "#d93349" }}
              onClick={() => {
                setOpen(false);
                setConfirm(false);
              }}
            >
            </Button> */}
            <Button
              onClick={() => {
                navigate("/login")
                setOpen(false);
              }}
              sx={{ color: "white" }}
            >
              Continue
            </Button>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
}
